module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Draggable', {
    staticClass: "panel",
    class: {
      selected: _vm.isSelected
    },
    style: (_vm.panelStyle),
    attrs: {
      "options": {
        animation: 350,
        group: _vm.parentName,
        xxxhandle: '.menu-icon'
      }
    },
    on: {
      "end": _vm.afterDrag
    },
    nativeOn: {
      "click": function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.selectPanel(_vm.panel)
      }
    },
    model: {
      value: (_vm.tree.panels),
      callback: function($$v) {
        _vm.$set(_vm.tree, "panels", $$v)
      },
      expression: "tree.panels"
    }
  }, [(_vm.isSelected) ? _c('div', {
    staticClass: "overlay-heading higher"
  }, [_vm._v("\n        " + _vm._s(_vm.panel.name) + "\n        "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "dark": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.navigateUp($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "dark": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showDialog($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("more_horiz")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.panel.placeholderText) ? _c('div', {
    domProps: {
      "textContent": _vm._s(this.placeholderText)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tree.panels), function(panel) {
    return _c('LayoutPanel', {
      key: panel.name,
      attrs: {
        "tree": _vm.getChildTree(panel),
        "parent": _vm.tree
      }
    })
  }), _vm._v(" "), _c('PanelDialog', {
    attrs: {
      "dialog": _vm.panelDialog
    },
    on: {
      "save": _vm.saveField
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f38dfab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LayoutPanel.vue
// module id = 2622
// module chunks = 1